var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.form,
            "label-col": _vm.labelCol,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-row",
            { staticClass: "flex-row" },
            [
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "客户数量", prop: "customerCount" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.customerCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customerCount", $$v)
                          },
                          expression: "form.customerCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "车辆数", prop: "vehicleCount" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.vehicleCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "vehicleCount", $$v)
                          },
                          expression: "form.vehicleCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "客户品系", prop: "strainsNameList" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            gap: "4px",
                            width: "100%",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                mode: "multiple",
                                placeholder: "请选择品系",
                                "collapse-tags": true,
                                disabled: _vm.isDisabled(),
                              },
                              on: { change: _vm.onStrainsChange },
                              model: {
                                value: _vm.form.strainsNameList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "strainsNameList", $$v)
                                },
                                expression: "form.strainsNameList",
                              },
                            },
                            _vm._l(_vm.carStrainsDS, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.strainsCode,
                                  attrs: { value: item.strains },
                                },
                                [_vm._v(_vm._s(item.strains))]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#999",
                                "font-size": "12px",
                                "line-height": "1.4",
                              },
                            },
                            [_vm._v(" 注意：公路用车与工程用车不可同时选择 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "地点", prop: "activityPlace" } },
                    [
                      _c("a-cascader", {
                        attrs: {
                          options: _vm.regionOptions,
                          fieldNames: {
                            label: "areaName",
                            value: "areaName",
                            children: "children",
                          },
                          placeholder: "请选择地点",
                          allowClear: "",
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.activityPlace,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityPlace", $$v)
                          },
                          expression: "form.activityPlace",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "详细地址" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.addressInfo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addressInfo", $$v)
                          },
                          expression: "form.addressInfo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "负责人姓名", prop: "headName" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headName", $$v)
                          },
                          expression: "form.headName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "负责人电话", prop: "headPhone" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headPhone", $$v)
                          },
                          expression: "form.headPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "sign-tiem widthHuo",
                      attrs: { label: "备注", "label-col": { span: 4 } },
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          "auto-size": { minRows: 2, maxRows: 6 },
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "item-line" }, [_vm._v("费用预算")]),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "会务费" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.conferenceFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "conferenceFee", $$v)
                          },
                          expression: "form.conferenceFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "油费" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.fuelCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fuelCost", $$v)
                          },
                          expression: "form.fuelCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "过路费" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.toll,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "toll", $$v)
                          },
                          expression: "form.toll",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "礼品费" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.giftFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "giftFee", $$v)
                          },
                          expression: "form.giftFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "布展费" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.moveInFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "moveInFee", $$v)
                          },
                          expression: "form.moveInFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "其他" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.otherFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "otherFee", $$v)
                          },
                          expression: "form.otherFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "合计" } },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: "" },
                        model: {
                          value: _vm.form.totalCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalCost", $$v)
                          },
                          expression: "form.totalCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.approveBtnDisplay === true
            ? _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "经销商已补差" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.dealerDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dealerDiff", $$v)
                              },
                              expression: "form.dealerDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "区域已补差" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.areaDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "areaDiff", $$v)
                              },
                              expression: "form.areaDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "最高支持费用" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.isDisabled() },
                            model: {
                              value: _vm.form.maxSupportFee,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "maxSupportFee", $$v)
                              },
                              expression: "form.maxSupportFee",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticClass: "car-modal",
          attrs: {
            title: "选择车型",
            visible: _vm.showCarSeries,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCarSeries = $event
            },
            cancel: function ($event) {
              _vm.showCarSeries = false
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "max-height":
                  _vm.$store.state.app.height - 350 < 185
                    ? 185
                    : _vm.$store.state.app.height - 350,
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                "checkbox-config": { checkRowKeys: _vm.defaultSelecteRows },
                data: _vm.carList,
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "checkbox", width: "60", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "vCode", title: "车型", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  field: "quantity",
                  title: "车型数量",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("a-input-number", {
                          attrs: { min: 0 },
                          model: {
                            value: row.quantity,
                            callback: function ($$v) {
                              _vm.$set(row, "quantity", $$v)
                            },
                            expression: "row.quantity",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCarSeries = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: { click: _vm.onSeriesConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }